import React, { FunctionComponent } from 'react';

import _ from 'lodash';

import { Select } from 'core/select/Select';
import { AgeRange } from 'social/publisher/Publisher.types';

interface Props {
    ages: AgeRange | undefined;
    save: any;
}

type Option = {
    value: number;
    label: string;
};
const AGE_RANGE = { MIN: 13, MAX: 65 };
const getAgeOptions = (min: number, max: number): Option[] => {
    const options = [];

    for (let i = min; i <= max; i++) {
        options.push({ value: i, label: `${i}` });
    }
    return options;
};
const getAgeMinOptions = (): Option[] => {
    return getAgeOptions(AGE_RANGE.MIN, AGE_RANGE.MAX);
};
const getAgeMaxOptions = (): Option[] => {
    const options = getAgeOptions(AGE_RANGE.MIN, AGE_RANGE.MAX - 1);

    options.push({ value: AGE_RANGE.MAX, label: `${AGE_RANGE.MAX}+` });
    return options;
};
const ageMinOptions = getAgeMinOptions();
const defaultAgeMinOption = ageMinOptions[0];
const ageMaxOptions = getAgeMaxOptions();
const defaultMaxAgeOption = ageMaxOptions[ageMaxOptions.length - 1];

export const AgeField: FunctionComponent<Props> = ({ ages, save }) => {
    let selectedMinAgeOption = defaultAgeMinOption;
    let selectedMaxAgeOption = defaultMaxAgeOption;

    if (ages?.ageMin) {
        selectedMinAgeOption = _.find(ageMinOptions, { value: ages?.ageMin }) as Option;
    }
    if (ages?.ageMax) {
        selectedMaxAgeOption = _.find(ageMaxOptions, { value: ages?.ageMax }) as Option;
    }

    const hanldeMinAgeChange = (selectedOption: Option): void => {
        const newAgeMin = _.get(selectedOption, 'value');

        if (newAgeMin) {
            let newAgeMax = ages?.ageMax || defaultMaxAgeOption.value;

            if (newAgeMax < newAgeMin) {
                newAgeMax = newAgeMin;
            }
            save({ ageMin: newAgeMin, ageMax: newAgeMax });
        }
    };

    const hanldeMaxAgeChange = (selectedOption: Option): void => {
        const newAgeMax = _.get(selectedOption, 'value');

        if (newAgeMax) {
            let newAgeMin = ages?.ageMin || defaultAgeMinOption.value;

            if (newAgeMax < newAgeMin) {
                newAgeMin = newAgeMax;
            }
            save({ ageMin: newAgeMin, ageMax: newAgeMax });
        }
    };

    return (
        <div className="age-selectors">
            <Select
                options={ageMinOptions}
                onChange={hanldeMinAgeChange}
                value={selectedMinAgeOption}
                className="age-selector age-min"
            />
            <Select
                options={ageMaxOptions}
                onChange={hanldeMaxAgeChange}
                value={selectedMaxAgeOption}
                className="age-selector age-max"
            />
        </div>
    );
};
